module.exports = __webpack_public_path__ + "user/static/media/logo.1c530a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/atoms/Logo/logo.png
// module id = 313
// module chunks = 38